import React from 'react';

import {BaseProps} from "../../../../../infrastructure/models/props/base-props";
import {GameCenterHeaderModuleController} from "../game-center-header-module.controller";
import {RectangleLabel} from "../../../../../core/components/misc/rectangle-label/rectangle-label";
import styles from "../styles/game-center-header.module.scss";
import classNames from "classnames";

export class GameCenterHeaderModuleWinDescriptionProps extends BaseProps {
  controller: GameCenterHeaderModuleController;
}

export const GameCenterHeaderModuleWinDescription = ({controller, className}: GameCenterHeaderModuleWinDescriptionProps) => {
  const {state} = controller;
    const {winDescription, device} = state;

  const winnerDescriptionProps = {
    device,
    className,
    isVisible: winDescription,
    colorLabelClassName: classNames(styles.winner_label)
  };

  return (
    winDescription ? <RectangleLabel {...winnerDescriptionProps}>{winDescription}</RectangleLabel> : null
  )
};
